import React, { Component } from "react";
import { ModalAddConditionContainer } from "./modal-tarjeta-style";
import { images } from "../../../../assets";
import H4Text from "../../../../components/components-text/h4-text";

interface IModalAddConditionProps {
  close: () => void;
  title: string;
  datosTarjeta: any
}

interface IModalAddConditionState {
  datta: string;
}

export interface ICondition {
  unit: string;
  productLines: string[];
  products: string[];
  value: number;
}

class ModalTarjetas extends Component<
  IModalAddConditionProps,
  IModalAddConditionState
> {
  containerRef: any;

  constructor(props: IModalAddConditionProps) {
    super(props);
    this.containerRef = React.createRef();
  }



  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside.bind(this));
  }


  isVisible(e: any) {
    return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
  }

  handleClickOutside(ev: any) {
    const { close } = this.props;
    this.isVisible(ev.target) &&
      this.containerRef.current &&
      !this.containerRef.current.contains(ev.target) &&
      close();
  }


  render() {
    const { title, datosTarjeta, close } = this.props;
    return (
      <ModalAddConditionContainer>
        <div className="modal-add-condition-aux-container">
          <div
            className="modal-add-condition-container"
            ref={this.containerRef}
          >
            <div className="modal-add-condition-close">
              <img src={images.IconCloseGrey} onClick={() => close()} />
            </div>
            <div className="card">
              <div className="card-header">
                <div>
                  <h2>{datosTarjeta.TipoTarjeta ? datosTarjeta.TipoTarjeta : '-'}</h2>
                </div>
              </div>
              <div className="card-grid">
                <div>
                  <p className="card-data">Versión: {datosTarjeta.Version ? datosTarjeta.Version : '-'}</p>
                  <p className="card-data">Estado: {datosTarjeta.Estado ? datosTarjeta.Estado : '-'}</p>
                </div>
                {/* <div>
                  <p className="card-data">Número:</p>
                  <p className="card-data">{datosTarjeta.Numero ? datosTarjeta.Numero : '-'}</p>
                </div> */}
              </div>
              <div className="card-content">
                <p className="card-title">Titular:</p>
                <p className="card-data">{datosTarjeta.Titular ? datosTarjeta.Titular : '-'}</p>
              </div>

              <div className="card-grid">
                <div>
                  <p className="card-title">Fecha de Efecto:</p>
                  <p className="card-data">{datosTarjeta.FechaEfecto ? datosTarjeta.FechaEfecto : '-'}</p>
                </div>
                <div>
                  <p className="card-title">Fecha de Caducidad:</p>
                  <p className="card-data">{datosTarjeta.FechaCaducidad ? datosTarjeta.FechaCaducidad : '-'}</p>
                </div>
                <div>
                  <p className="card-title">Fecha de Estado:</p>
                  <p className="card-data">{datosTarjeta.FechaEstado ? datosTarjeta.FechaEstado : '-'}</p>
                </div>
                <div>
                  <p className="card-title">Duplicado:</p>
                  <p className="card-data">{datosTarjeta.Duplicado ? datosTarjeta.Duplicado : '-'}</p>
                </div>
              </div>
              <div className="card-content">
                <p className="card-title">Domicilio:</p>
                <p className="card-data">{datosTarjeta.Domicilio ? datosTarjeta.Domicilio : '-'}</p>
              </div>
            </div>
          </div>
        </div>
      </ModalAddConditionContainer>
    );
  }
}

export default ModalTarjetas;
